/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/9/22, 7:45 AM
 *
 */

import { ApiNullResponse, ApiResponse } from 'types/api';
import { Member } from 'types/MemberTypes';

import { privateAgent } from 'config/axios';

export const getUserProfile = async (): Promise<Member> => {
  const response = await privateAgent.get<ApiResponse<Member>>('auth/me');
  return response?.data.data;
};

export const changePassword = (old_password: string, new_password: string) => {
  return new Promise((resolve, reject) => {
    privateAgent
      .patch<ApiNullResponse>('auth/change_password', {
        old_password,
        new_password,
      })
      .then((response) => {
        resolve(response.data.message);
      })
      .catch((error) => {
        reject(error.response);
      });
  });
};

export const resetPassword = (id: number) => {
  return new Promise((resolve, reject) => {
    privateAgent
      .patch<ApiNullResponse>(`auth/reset/${id}`)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error.response);
      });
  });
};
